<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" class="form-control form-control-sm w-250px ps-12" placeholder="Search invoices..."
          [(ngModel)]="searchTerm" (input)="onSearchInput($event)" />
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-table-toolbar="base">
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3"
          [class.active]="showFilters"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Search</span>
        </button>
        <button type="button" class="btn btn-sm btn-primary me-3 text-nowrap" (click)="exportExcel()" [disabled]="isExportingExcel">
          <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isExportingExcel" class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingExcel ? 'Exporting...' : 'Export' }}</span>
        </button>
        <!-- Commission Status Links -->
        <div class="d-flex align-items-center">
          <a href="javascript:;"
             class="text-decoration-none me-4 fw-bold"
             [class.text-primary]="selectedCommissionStatus === 'pending'"
             [class.text-muted]="selectedCommissionStatus !== 'pending'"
             (click)="onCommissionStatusFilter('pending')">
            Pending
          </a>
          <a href="javascript:;"
             class="text-decoration-none me-4 fw-bold"
             [class.text-primary]="selectedCommissionStatus === 'tentative'"
             [class.text-muted]="selectedCommissionStatus !== 'tentative'"
             (click)="onCommissionStatusFilter('tentative')">
            Tentative
          </a>
          <a href="javascript:;"
             class="text-decoration-none fw-bold"
             [class.text-primary]="selectedCommissionStatus === 'completed'"
             [class.text-muted]="selectedCommissionStatus !== 'completed'"
             (click)="onCommissionStatusFilter('completed')">
            Completed
          </a>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center d-none" data-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span class="me-2" data-table-select="selected_count"></span>Selected
        </div>
        <button type="button" class="btn btn-sm btn-dark" data-table-select="delete_selected">Delete Selected</button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4 commission-filters" *ngIf="showFilters" [@slideInOut]>
    <div class="row g-4">
      <!-- Sales Agent Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Agent</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Sales Agent..."
            [(ngModel)]="salesAgentSearchTerm"
            (input)="onSalesAgentSearchInput($event)"
            (focus)="onSalesAgentInputFocus()"
            (blur)="onSalesAgentInputBlur()"
            autocomplete="off" />

          <!-- Loading Spinner -->
          <div *ngIf="isSalesAgentSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
            <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
          </div>

          <!-- Dropdown Results -->
          <div class="dropdown-menu show w-100 mh-200px overflow-auto" *ngIf="showSalesAgentDropdown">
            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isSalesAgentSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching...
            </div>

            <!-- Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let salesAgent of salesAgentSearchResults"
               (click)="selectSalesAgent(salesAgent)">
              {{ getSalesAgentDisplayName(salesAgent) }}
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isSalesAgentSearching && salesAgentSearchResults.length === 0">
              No sales agents found
            </div>
          </div>
        </div>
      </div>

      <!-- Client Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Client</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Client..."
            [(ngModel)]="clientSearchTerm"
            (input)="onClientSearchInput($event)"
            (focus)="onClientInputFocus()"
            (blur)="onClientInputBlur()"
            autocomplete="off" />

          <!-- Loading Spinner -->
          <div *ngIf="isClientSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
            <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
          </div>

          <!-- Dropdown Results -->
          <div class="dropdown-menu show w-100 mh-200px overflow-auto" *ngIf="showClientDropdown">
            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isClientSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching...
            </div>

            <!-- Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let client of clientSearchResults"
               (click)="selectClient(client)">
              {{ getClientDisplayName(client) }}
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isClientSearching && clientSearchResults.length === 0">
              No clients found
            </div>
          </div>
        </div>
      </div>

      <!-- Ship Name Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Ship Name</label>
        <div class="position-relative">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search Ship..."
            [(ngModel)]="shipSearchTerm"
            (input)="onShipSearchInput($event)"
            (focus)="onShipInputFocus()"
            (blur)="onShipInputBlur()"
            autocomplete="off" />

          <!-- Loading Spinner -->
          <div *ngIf="isShipSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
            <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
          </div>

          <!-- Dropdown Results -->
          <div class="dropdown-menu show w-100 mh-200px overflow-auto" *ngIf="showShipDropdown">
            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isShipSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching...
            </div>

            <!-- Results -->
            <a class="dropdown-item cursor-pointer py-2"
               *ngFor="let ship of shipSearchResults"
               (click)="selectShip(ship)">
              {{ getShipDisplayName(ship) }}
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
                 *ngIf="!isShipSearching && shipSearchResults.length === 0">
              No ships found
            </div>
          </div>
        </div>
      </div>

      <!-- Stock Number -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Stock Number</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter Stock Number..."
          [(ngModel)]="filters.stock_number">
      </div>
    </div>

    <!-- Second Row -->
    <div class="row g-4 mt-2">
      <!-- Sailing From Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sailing From Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.sailing_from_date">
      </div>

      <!-- Sailing To Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sailing To Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.sailing_to_date">
      </div>

      <!-- Arrival From Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Arrival From Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.arrival_from_date">
      </div>

      <!-- Arrival To Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Arrival To Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.arrival_to_date">
      </div>
    </div>

    <!-- Third Row -->
    <div class="row g-4 mt-2">
      <!-- Invoice From Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Invoice From Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.invoice_from_date">
      </div>

      <!-- Invoice To Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Invoice To Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.invoice_to_date">
      </div>

      <!-- Sales Commission From Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Commission From Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.sales_commission_from_date">
      </div>

      <!-- Sales Commission To Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Commission To Date</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.sales_commission_to_date">
      </div>
    </div>

    <!-- Fourth Row -->
    <div class="row g-4 mt-2">
      <!-- Destination Country -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Destination Country</label>
        <select
          class="form-select form-select-sm"
          [(ngModel)]="filters.destination_country"
          (change)="onCountryChange()">
          <option value="">Select Country...</option>
          <option *ngFor="let country of countries" [value]="country.code">
            {{ country.name }}
          </option>
        </select>
      </div>

      <!-- Destination Port -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Destination Port</label>
        <select
          class="form-select form-select-sm"
          [(ngModel)]="filters.destination_port"
          [disabled]="isPortsDisabled">
          <option value="">Select Port...</option>
          <option *ngFor="let port of ports" [value]="port._id">
            {{ port.name }}
          </option>
        </select>
      </div>

      <!-- Filter Actions -->
      <div class="col-md-6 d-flex align-items-end justify-content-end">
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
            <i class="ki-duotone ki-cross fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Copy SMJ# Section (appears when invoices are selected) -->
  <div class="card-body py-3" *ngIf="selectedInvoices.size > 0">
    <div class="alert alert-info d-flex align-items-center">
      <div class="d-flex align-items-center flex-grow-1">
        <i class="ki-duotone ki-information-5 fs-2 text-info me-3">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </i>
        <span class="fw-bold fs-6 me-4">{{ selectedInvoices.size }} invoice(s) selected</span>
        <button class="btn btn-sm btn-primary me-2" (click)="onCopySMJNumbers()">
          <i class="ki-duotone ki-copy fs-4 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Copy SMJ#
        </button>
        <button class="btn btn-sm btn-light" (click)="onClearSelection()">
          <i class="ki-duotone ki-cross fs-4 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Clear Selection
        </button>
      </div>
    </div>
  </div>

  <div class="card-body pt-0">
    <!-- Save Button (appears when changes are made) -->
    <div *ngIf="hasChanges" class="d-flex justify-content-end mb-3">
      <button type="button" class="btn btn-sm btn-success" (click)="onSave()" [disabled]="isLoading">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        <i *ngIf="!isLoading" class="ki-duotone ki-check fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        {{ isLoading ? 'Saving...' : 'Save Changes' }}
      </button>
    </div>

    <!-- Commission Table with Sticky Column -->
    <div *ngIf="!isLoading && invoices.length > 0" class="commission-table-container">
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 commission-table">
          <thead>
            <tr class="fw-bold text-muted bg-primary-subtle">
              <!-- Sticky Invoice Number Column -->
              <th class="sticky-column min-w-180px">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input class="form-check-input"
                           type="checkbox"
                           [checked]="isAllSelected()"
                           [indeterminate]="isIndeterminate()"
                           (change)="onSelectAll($event)" />
                  </div>
                  Invoice #
                </div>
              </th>
              <!-- Scrollable Columns -->
              <th class="min-w-80px text-center">Sold</th>
              <th class="min-w-80px text-center">Doc</th>
              <th class="min-w-80px text-center">DHL</th>
              <th class="min-w-100px text-center">Status</th>
              <th class="min-w-120px">Model</th>
              <th class="min-w-80px">Year</th>
              <th class="min-w-120px">Model Code</th>
              <th class="min-w-150px">Chassis #</th>
              <th class="min-w-150px">Sales Commission (JPY)</th>
              <th class="min-w-150px">Sales Commission Date</th>
              <th class="min-w-120px">Proforma Date</th>
              <th class="min-w-120px">Invoice Date</th>
              <th class="min-w-120px">Invoice Amount</th>
              <th class="min-w-120px">Allocated Amount</th>
              <th class="min-w-100px">Balance</th>
              <th class="min-w-80px">Paid(%)</th>
              <th class="min-w-120px">Broker</th>
              <th class="min-w-150px">Consignee Name</th>
              <th class="min-w-120px">Notify Party</th>
              <th class="min-w-100px">Ship Type</th>
              <th class="min-w-120px">CTN Group No.</th>
              <th class="min-w-120px">Ship Name</th>
              <th class="min-w-100px">Voyage #</th>
              <th class="min-w-120px">Sailing Port</th>
              <th class="min-w-120px">Sailing Date</th>
              <th class="min-w-120px">Arrival date</th>
              <th class="min-w-150px">Destination Port</th>
              <th class="min-w-150px">Destination Country</th>
              <th class="min-w-120px">Yard Name</th>
              <th class="min-w-120px">Courier Date</th>
              <th class="min-w-100px">Re Auction</th>
              <th class="min-w-150px">Invoice Create By</th>
              <th class="min-w-120px">Sales Person</th>
              <th class="min-w-100px">Contract</th>
              <th class="min-w-120px">Contact Info</th>
              <th class="min-w-100px">Actions</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loading state -->
            <tr *ngIf="isLoading">
              <td colspan="37" class="text-center py-5">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Loading invoices...
                </div>
              </td>
            </tr>

            <!-- No data state -->
            <tr *ngIf="!isLoading && invoices.length === 0">
              <td colspan="37" class="text-center py-5 text-muted">
                No invoices found
              </td>
            </tr>

            <!-- Data rows -->
            <tr *ngFor="let invoice of invoices; trackBy: trackByInvoiceId"
                class="cursor-pointer"
                (click)="openInvoiceDetailModal(invoice)"
                style="cursor: pointer;"
                title="Click to view invoice details">
              <!-- Sticky Invoice Number Column -->
              <td class="sticky-column">
                <div class="d-flex align-items-center">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input class="form-check-input invoice-number-check"
                           type="checkbox"
                           [value]="invoice._id"
                           [checked]="isInvoiceSelected(invoice._id)"
                           (change)="onInvoiceSelect(invoice._id, $event)"
                           (click)="$event.stopPropagation()" />
                  </div>
                  <span class="fw-bold text-primary">{{ invoice.vehicle.car_no }}</span>
                </div>
              </td>
              <!-- Scrollable Columns -->
              <td class="text-center">
                <div class="badge" [ngClass]="invoice.sold ? 'badge-light-success' : 'badge-light-danger'">
                  {{ invoice.sold ? 'Yes' : 'No' }}
                </div>
              </td>
              <td class="text-nowrap text-center">
                <a href="#">
                  <i class="ki-duotone ki-document fs-1 text-gray-800 text-hover-primary">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </a>
              </td>
              <td class="text-nowrap text-center">
                <a href="#">
                  <i class="ki-duotone ki-information-2 fs-1 text-gray-800 text-hover-primary">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </i>
                </a>
              </td>
              <!-- <td class="text-nowrap">
                <div class="form-check form-check-sm form-check-custom form-check-solid">
                  <a href="javascript:;"
                    (click)="invoiceStatus(invoice._id,invoice.status); $event.stopPropagation()">{{invoice.status=="approved"?"Un Approve":"Approve"}}</a>
                </div>
              </td> -->
              <td class="text-nowrap text-center" [attr.data-order]="invoice.status">
                <div class="badge" [ngClass]="{
                  'badge-light-success': invoice.status === 'approved',
                  'badge-light-warning': invoice.status === 'pending',
                  'badge-light-danger': invoice.status === 'cancelled' || invoice.status === 'unapproved'
                }">
                  {{ invoice.status | titlecase }}
                </div>
              </td>
              <td class="text-nowrap">{{ invoice.vehicle?.model || '-' }}</td>
              <td class="text-nowrap">{{ invoice.vehicle?.year || '-' }}</td>
              <td class="text-nowrap">{{ invoice.vehicle?.body_type || '-' }}</td>
              <td class="text-nowrap">{{ invoice.vehicle?.chassis_no || '-' }}</td>
              <td>
                <input type="number" class="form-control form-control-sm"
                       autocomplete="off"
                       [ngModel]="getFormValue(invoice._id, 'sales_commission')"
                       (ngModelChange)="setFormValue(invoice._id, 'sales_commission', $event)"
                       placeholder="Enter commission"
                       (click)="$event.stopPropagation()">
              </td>
              <td>
                <input type="date" class="form-control form-control-sm"
                       autocomplete="off"
                       [ngModel]="getFormValue(invoice._id, 'sales_commission_date')"
                       (ngModelChange)="setFormValue(invoice._id, 'sales_commission_date', $event)"
                       (click)="$event.stopPropagation()">
              </td>
              <td class="text-nowrap">{{ formatDate(invoice.order?.order_date) }}</td>
              <td class="text-nowrap">{{ formatDate(invoice.invoice_date) }}</td>
              <td class="text-nowrap">{{ formatCurrency(invoice.invoice_amount, invoice.item?.currency) }}</td>
              <td class="text-nowrap">{{ formatCurrency(invoice.paid, invoice.item?.currency) }}</td>
              <td class="text-nowrap">{{ formatCurrency(invoice.balance, invoice.item?.currency) }}</td>
              <td class="text-nowrap">{{ calculatePaidPercentage(invoice.paid, invoice.invoice_amount) }}</td>
              <td class="text-nowrap">{{ invoice.created_by?.name || '-' }}</td>
              <td class="text-nowrap"><a title="Click to view Consignee Details" (click)="viewDetailClient(invoice.order?.buyer_id)" style="cursor: pointer;">{{ invoice.order?.buyer_consignee_name || '-' }}</a></td>
              <td class="text-nowrap">-</td>
              <td class="text-nowrap">{{ invoice.order?.ship_type || '-' }}</td>
              <td class="text-nowrap">{{ invoice.order?.group_no || '-' }}</td>
              <td class="text-nowrap">{{ invoice.ship?.name || '-' }}</td>
              <td class="text-nowrap">{{ invoice.ship?.voyage_no || '-' }}</td>
              <td class="text-nowrap">{{ invoice.order?.from_port || '-' }}</td>
              <td class="text-nowrap">{{ invoice.ship?formatDate(invoice.ship?.sailing_date):'-' }}</td>
              <td class="text-nowrap">{{ invoice.ship?formatDate(invoice.ship?.arrival_date):'-' }}</td>
              <td class="text-nowrap">{{ invoice.order?.to_port || '-' }}</td>
              <td class="text-nowrap">{{ invoice.order?.to_country || '-' }}</td>
              <td class="text-nowrap">{{ invoice.vehicle?.yard_name || '-' }}</td>
              <td class="text-nowrap">{{ formatDate(invoice.courier_date) }}</td>
              <td class="text-nowrap">
                  {{ invoice.re_auction ? 'Yes' : 'No' }}
              </td>
              <td class="text-nowrap">{{ invoice.created_by?.name || '-' }}</td>
              <td class="text-nowrap">{{ invoice.created_by?.name || '-' }}</td>
              <td class="text-nowrap text-center">
                <div class="badge" [ngClass]="invoice.contract ? 'badge-light-success' : 'badge-light-danger'">
                  {{ invoice.contract ? 'Yes' : 'No' }}
                </div>
              </td>
              <td class="text-nowrap text-center">
                <a href="#" *ngIf="invoice.con_info">
                  <i class="ki-duotone ki-information-2 fs-1 text-gray-800 text-hover-primary">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </i>
                </a>
                <span *ngIf="!invoice.order.buyer_telephone_no">-</span>
              </td>
              <td class="text-nowrap">
                <a href="#" class="btn btn-light btn-active-light-primary btn-sm"
                   data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                   (click)="$event.stopPropagation()">
                  Actions <i class="ki-duotone ki-down fs-5 m-0"></i>
                </a>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">View</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">Edit</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" data-table-filter="delete_row" class="menu-link px-3">Delete</a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Loading state (outside table) -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="d-flex align-items-center justify-content-center">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Loading invoices...
      </div>
    </div>

    <!-- No data state (outside table) -->
    <div *ngIf="!isLoading && invoices.length === 0" class="text-center py-5 text-muted">
      No invoices found
    </div>
  </div>

  <!-- Pagination -->
  <div class="row" *ngIf="!isLoading && invoices.length > 0">
    <div class="col-sm-6 py-4 d-flex align-items-center">
      <div class="text-muted">
        Showing {{ ((paginationInfo.currentPage - 1) * paginationInfo.perPage) + 1 }}
        to {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }}
        of {{ paginationInfo.total }} records
      </div>
    </div>
    <div class="col-sm-6 py-4 d-flex justify-content-end">
      <nav aria-label="pagination" class="dt-paging paging_full">
        <ul class="pagination">
          <!-- First page -->
          <li class="dt-paging-button page-item" [class.disabled]="paginationInfo.currentPage === 1">
            <button type="button" class="btn btn-sm btn-primary page-link first"
              [disabled]="paginationInfo.currentPage === 1" (click)="onPageChange(1)">
              <i class="ki-duotone ki-double-left">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </button>
          </li>

          <!-- Previous page -->
          <li class="dt-paging-button page-item" [class.disabled]="paginationInfo.currentPage === 1">
            <button type="button" class="btn btn-sm btn-primary page-link previous"
              [disabled]="paginationInfo.currentPage === 1" (click)="onPageChange(paginationInfo.currentPage - 1)">
              <i class="ki-duotone ki-left"></i>
            </button>
          </li>

          <!-- Page numbers -->
          <li class="dt-paging-button page-item" *ngFor="let page of getPageNumbers()"
            [class.active]="page === paginationInfo.currentPage">
            <button type="button" class="btn btn-sm btn-primary page-link"
              [attr.aria-current]="page === paginationInfo.currentPage ? 'page' : null" (click)="onPageChange(page)">
              {{ page }}
            </button>
          </li>

          <!-- Next page -->
          <li class="dt-paging-button page-item"
            [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
            <button type="button" class="btn btn-sm btn-primary page-link next"
              [disabled]="paginationInfo.currentPage === paginationInfo.lastPage"
              (click)="onPageChange(paginationInfo.currentPage + 1)">
              <i class="ki-duotone ki-right"></i>
            </button>
          </li>

          <!-- Last page -->
          <li class="dt-paging-button page-item"
            [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
            <button type="button" class="btn btn-sm btn-primary page-link last"
              [disabled]="paginationInfo.currentPage === paginationInfo.lastPage"
              (click)="onPageChange(paginationInfo.lastPage)">
              <i class="ki-duotone ki-double-right">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- Invoice PDF Preview Modal -->

<!-- Invoice Detail Modal -->
<app-invoice-detail-modal [invoice]="selectedInvoiceForDetail" [invoiceId]="selectedInvoiceIdForDetail">
</app-invoice-detail-modal>

<!-- Add Sales Commission Modal -->
<app-add-sales-commission [invoiceId]="selectedInvoiceIdForCommission"
  [invoiceNumber]="selectedInvoiceNumberForCommission" (commissionAdded)="onCommissionAdded()">
</app-add-sales-commission>
